export function uniqueObjectsByKey(arr, key) {
    const seen = new Set();
    return arr.filter(obj => !seen.has(obj[key]) && seen.add(obj[key]));
}